import type { BookingTranslateFn } from '../i18n/bookingFormLabels';
import type { MessageKey } from '../i18n/messages';

const BOOKING_SCHEDULE_ERROR_KEYS: Record<string, MessageKey> = {
  'Choose a start date and time.': 'bookings.scheduleError.chooseStart',
  'Choose an end date and time.': 'bookings.scheduleError.chooseEnd',
  'Start and end dates must be valid.': 'bookings.scheduleError.invalidDates',
  'End must be after start.': 'bookings.scheduleError.endBeforeStart',
  'Start time is too soon — choose a time at least a few minutes from now.':
    'bookings.scheduleError.startTooSoon',
  'Hourly bookings must start and end on the same day.': 'bookings.scheduleError.hourlySameDay',
  'Start time is too late — not enough time left today for an hourly booking.':
    'bookings.scheduleError.startTooLateToday',
  'Start date cannot be in the past.': 'bookings.scheduleError.startInPast',
  'Booking start date is missing — reload the booking and try again.':
    'bookings.scheduleError.missingBookingStart',
  'End date must be valid.': 'bookings.scheduleError.invalidEnd',
  'End must be after the booking start.': 'bookings.scheduleError.endBeforeBookingStart',
  'Hourly bookings must end on the same day as the start.':
    'bookings.scheduleError.hourlySameDayEnd',
  'End must align with complete booking periods.': 'bookings.scheduleError.periodAlign',
};

/** Map English schedule validation copy to localized UI text. */
export function localizeBookingScheduleError(message: string, t: BookingTranslateFn): string {
  const trimmed = message.trim();
  const key = BOOKING_SCHEDULE_ERROR_KEYS[trimmed];
  if (key) {
    return t(key);
  }
  const shortenMatch = /^Cannot shorten below (.+)\.$/.exec(trimmed);
  if (shortenMatch) {
    return t('bookings.scheduleError.cannotShortenBelow', { periods: shortenMatch[1] });
  }
  const periodCountMatch = /^End must match the period count \((.+)\) from the booking start\.$/.exec(
    trimmed,
  );
  if (periodCountMatch) {
    return t('bookings.scheduleError.periodCountMismatch', { periods: periodCountMatch[1] });
  }
  return message;
}
